import { PageLayout } from '@psyomics/ui-components';

import { ContentArticle } from './article/content-article';
import { ContentType } from './generated/content';

type ContentPageProps = {
  readonly type: ContentType;
  readonly id: string;
};

const handleUnknown = (type: never): never => {
  throw new Error('Unknown type: ' + type);
};

const ContentRender = ({ type, id }: ContentPageProps) => {
  switch (type) {
    case ContentType.Article:
      return <ContentArticle id={id} />;
    default:
      return handleUnknown(type);
  }
};

const ContentPage = (props: ContentPageProps) => {
  return (
    <PageLayout>
      <ContentRender {...props} />
    </PageLayout>
  );
};

export { ContentPage };
